import * as React from "react";
import {formatDate} from "@ui-seeker/utils";

import {ArrowBackground} from "@components";


/**
 * True when the last review is genuinely recent — within 30 days AND not in the future.
 *
 * The `days >= 0` half is not redundant. Some product pages report a review dated *after* the day
 * we scraped them, which is corrupt source data (598 products across 17 sites, handed to the
 * scraping team on 2026-08-24). Those come through as a negative number, and `-49 <= 30` is true,
 * so without the guard the cell went green — the loudest possible way to show a broken row as
 * healthy. Red is the decision: it is what the legacy backend already paints, since its unsigned
 * column overflows the negative into 4294967247 and fails the `<= 30` test by accident.
 *
 * ⚠️ Safe on both backends: the legacy one never sends a negative here, so this only changes what
 * the v2 rows paint.
 */
const isRecentReview = (days) => typeof days === 'number' && days >= 0 && days <= 30


export default function lastReviewColumn() {
	return [{
		name: 'lastReview', label: 'Last review\ndate',
		options: {
			display: 'excluded',
			customBodyRowRender: (value, { daysLastReview }) => {
				if (!value)
					return 'N/A'
				return isRecentReview(daysLastReview) ? 'Yes' : 'No'
			}
		}
	},{
		name: 'lastReview', label: 'Last review\ndate',
		options: {
			filter: false,
			setCellHeaderProps: () => ({ sx: {
					whiteSpace: 'pre-wrap',
					minWidth: 160
				}}),
			customBodyRowRenderLite: (value, { daysLastReview }) => {
				let backgroundColor = 'error.lighter'

				if (isRecentReview(daysLastReview))
					backgroundColor = 'success.lighter'

				if (!value) return <></>

				return <ArrowBackground value={value} backgroundColor={backgroundColor}>
					{formatDate(value, { isString: true })}
				</ArrowBackground>
			}
		}
	}]
}